import gql from "graphql-tag";

// Get list of Leave type
const GET_LEAVE_TYPE = gql`
	query Get_LeaveTypes($site: ID!) {
		GetLeaveTypes(site: $site) {
			docs {
				created_at
				id
				name
			}
		}
	}
`;

// New LeaveType
const NEW_LEAVE_TYPE = gql`
	mutation NewLeaveType($name: String!, $site: ID!) {
		CreateLeaveType(name: $name, site: $site) {
			message
			doc {
				name
				id
				created_at
			}
		}
	}
`;
// Update LeaveType
const UPDATE_LEAVE_TYPE = gql`
	mutation UpdateLeaveType($name: String!, $id: ID!) {
		UpdateLeaveType(name: $name, id: $id) {
			message
			doc {
				name
				id
				created_at
			}
		}
	}
`;

export { GET_LEAVE_TYPE, NEW_LEAVE_TYPE, UPDATE_LEAVE_TYPE };
